export default (params) => ({
  trigger: {
    name: 'product_trade_in_overlay.click_on_next_previous',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      direction: {
        enum: [
          'next',
          'previous',
        ],
      },
      sub_feature: {
        enum: [
          'brand',
          'product',
          'condition',
          'instructions',
        ],
      },
    },
    event: {
      name: 'select_direction',
      params: {
        visible_indices: null,
        visible_items: null,
      },
    },
  },
});
